import { apiClient } from './client';
import type { TeamMember, Invitation, InviteRequest, InviteInfo } from '@/types/auth';

export const teamApi = {
  getMembers: () =>
    apiClient.get<TeamMember[]>('/api/team/members'),

  getInvitations: () =>
    apiClient.get<Invitation[]>('/api/team/invitations'),

  invite: (data: InviteRequest) =>
    apiClient.post<Invitation>('/api/team/invitations', data),

  cancelInvitation: (id: string) =>
    apiClient.delete(`/api/team/invitations/${id}`),

  removeMember: (userId: string) =>
    apiClient.delete(`/api/team/members/${userId}`),

  updateRole: (userId: string, role: string) =>
    apiClient.patch<TeamMember>(`/api/team/members/${userId}/role`, { role }),

  updateMember: (userId: string, data: { firstName?: string; lastName?: string; email?: string }) =>
    apiClient.put<TeamMember>(`/api/team/members/${userId}`, data),

  getInviteInfo: (token: string) =>
    apiClient.get<InviteInfo>(`/api/team/invite/${token}`),

  acceptInvite: (token: string, password?: string) =>
    apiClient.post<{ message: string; organizationName: string; organizationId: string }>(
      `/api/team/invite/${token}/accept`,
      { password }
    ),
};
